<template>
    <li class="search-filters-option">
        <label :for="getInputId">
            <input ref="checkbox" @change="handleChange" type="checkbox" :checked="value" :id="getInputId">
            {{ name }} ({{ count }})
        </label>
    </li>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        value: {
            type: Boolean,
            required: true,
            default: false
        },
        count: {
            type: Number,
            required: true,
            default: 0,
        },
        type: {
            type: String,
            required: true
        },
        taxonomy: {
            type: String,
            required: false,
            default: null,
        },
        slug: {
            type: String,
            required: false,
            default: null
        }
    },

    async mounted() {
        // for debug to see what is current active element
        // setInterval("console.log('active element', document.activeElement)", 5000);
        this.focusInput();
    },

    computed: {

        /**
         * Return object of filtered parameters.
         *
         * @return {{type: String, slug: String}}
         */
        filterObject () {
            let object = { type: this.type, slug: this.slug };
            if (this.type === 'taxonomy') {
                Object.assign(object, { taxonomy: this.taxonomy });
            }
            return object;
        },

        /**
         * Returns the ID of the input.
         * @return {string}
         */
        getInputId() {
            return `${this.type}-${this.slug}`;
        }
    },

    methods: {
        handleChange( e ) {

            const { checked } = this.$refs.checkbox;

            // Fire handler based on checkbox checked.
            checked ? this.addFilter() : this.removeFilter();

            this.$store.dispatch( 'deactivateFilters' );
            this.$store.dispatch( 'a11yLastClicked', this.$refs.checkbox );

            this.focusInput();
        },

        /**
         * Fire ADD handler.
         */
        addFilter () {
            this.$store.dispatch('addFilter', this.filterObject);
        },

        /**
         * Fire Remove handler.
         */
        removeFilter () {
            this.$store.dispatch('removeFilter', this.filterObject);
        },

        /**
         * Set focus to input.
         */
        focusInput() {
            const activeFilter = this.$store.getters.focusFilter;
            if ( !! activeFilter && activeFilter === this.$refs.checkbox ) {
                // on page reload checkbox loses refs that are present on mounted.
                // get the id of the refs checkbox on mounted to be able to find it again after full page load.
                const $checkbox = this.$refs.checkbox.getAttribute('id');
                // get checkbox by refs id.
                setTimeout(function () {
                    document.getElementById( $checkbox ).focus();
                }, 1000)
            }
        }
    }
};
</script>
